import SvgIcon from '@mui/material/SvgIcon';
import { omit } from 'ramda'

export default function StriebelIconSmall(props) {
  const fillColor = "#00a84d" 
  
  return (
    <SvgIcon
      width={props.width}
      height={props.height}
      viewBox="0 0 80 177"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...omit(['secondaryColor'], props)}
      sx={{
        width: props.width,
        height: props.height,
      }}
    >
      <g>
        <path style={{fill: fillColor}}  d="M35.03,53.44h12.53c1.19,0,2.15.96,2.15,2.15v65.68c0,1.19-.96,2.15-2.15,2.15h-12.53c-1.19,0-2.15-.97-2.15-2.15V55.59c0-1.19.96-2.15,2.15-2.15Z"/>
        <path style={{fill: fillColor}}  d="M80.33,53.44h-12.53c-1.19,0-2.15.97-2.15,2.16v98.45c0,3.37-2.74,6.12-6.12,6.12H2.15c-1.19,0-2.15.97-2.15,2.16v12.53c0,1.19.97,2.16,2.15,2.16h57.38c12.65,0,22.95-10.3,22.95-22.96V55.6c0-1.19-.97-2.16-2.15-2.16Z"/>
        <path style={{fill: fillColor}}  d="M80.43,0H24.12C10.87,0,.09,10.78.09,24.03v97.24c0,1.19.97,2.16,2.15,2.16h12.52c1.19,0,2.15-.97,2.15-2.16V24.03c0-3.97,3.23-7.19,7.19-7.19h56.3c1.19,0,2.15-.97,2.15-2.16V2.16c0-1.19-.97-2.16-2.15-2.16Z"/>
      </g>
    </SvgIcon>
  );
}


StriebelIconSmall.defaultProps = {
  color: '#046927',
  secondaryColor: '#C3010C',
  width: '16px',
  height: '23px',
};